export enum TransformerRequestCodes {
  ADD_FISCOD_FOREIGN_GUEST = 'AFFG',
  REMOVE_AUTO_SSV = 'RASSV',
  REMOVE_EMPTY_WEB_CHECKIN = 'REWC',
}
